import { memo } from 'react';

import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'ask_ai';

export const getDescription = (action: JourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        isColorful
        node={node}
        label={t('title')}
        descriptionText={node.data.description}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Ask AI',
    noDescription: 'No description',
  },
};
